/*
  PDP "Delivery & returns" side drawer.

  Wires the existing CTA under Add to Bag, which was an <a href="#"> with no
  handler -- the same dead-link pattern the Size Chart link had.

  The drawer is hoisted to <body> on open. position:fixed does NOT escape an
  ancestor stacking context, and this renders inside .product__info-wrapper
  (z-index 5) while the sticky header is z-index 50 -- so without hoisting, the
  DIESEL logo paints over the panel. Same fix as the size-chart popup.

  Opening is two-step so the slide-in animates: unhide first, then add .is-open
  on the next frame, since a transition cannot run from display:none.

  Document-delegated, so it survives the colour swap re-rendering the info card.
*/
(function () {
  var LOCK = 'drdrawer-open';

  function drawer() {
    return document.querySelector('[data-dr-drawer]');
  }

  function hoist(el) {
    if (!el || el.parentElement === document.body) return el;
    var stale = document.querySelectorAll('body > [data-dr-drawer]');
    for (var i = 0; i < stale.length; i++) stale[i].remove();
    document.body.appendChild(el);
    return el;
  }

  function open(el) {
    if (!el) return;
    el = hoist(el);
    el.hidden = false;
    // Next frame, so the transition has a from-state to animate out of.
    window.requestAnimationFrame(function () {
      el.classList.add('is-open');
    });
    document.documentElement.classList.add(LOCK);
    var close = el.querySelector('.drdrawer__close');
    if (close) close.focus();
  }

  function close(el) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    document.documentElement.classList.remove(LOCK);
    // Hide only once the slide-out has finished, so it is not cut short.
    window.setTimeout(function () {
      if (!el.classList.contains('is-open')) el.hidden = true;
    }, 280);
    var trigger = document.querySelector('[data-dr-open]');
    if (trigger) trigger.focus();
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-dr-open]')) {
      event.preventDefault();
      open(drawer());
      return;
    }
    if (t.closest('[data-dr-close]')) {
      event.preventDefault();
      close(drawer());
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close(drawer());
  });
})();
